module.exports = __webpack_public_path__ + "images/sprite-skin-flat.png";


//////////////////
// WEBPACK FOOTER
// ./web/js/module/ion-range-slider-angularjs-1.1.3/sprite-skin-flat.png
// module id = 926
// module chunks = 0